<template>
  <div class="trygame-box">
    <!-- <van-nav-bar
      left-arrow
      fixed
      safe-area-inset-top
      id="nav-topp"
      title="648福利"
    >
      <template #left>
        <img :src="state.backIcon" alt="" @click="onClickLeft" />
      </template>
      <template #right>
        <p @click="goMyCoupon">领取记录</p>
      </template>
    </van-nav-bar> -->
    <div class="trygame-content">
      <div class="tips-box">
        <!-- <p>3.返回当前页面，下拉刷新，领取奖励</p> -->
      </div>

      <div class="task-list" ref="taskList">
        <van-pull-refresh v-model="state.refresh" @refresh="onRefresh">
          <van-list
            v-model:loading="state.loading"
            :finished="state.finished"
            finished-text="更多游戏648券正在路上~"
            @load="onLoad"
          >
            <van-cell
              v-for="(item, i) in state.couponList"
              :key="i + '-hotlist'"
            >
              <div class="van-cell__title">
                <div
                  class="van-cell__left"
                  style="display: flex; align-items: center"
                >
                  <img
                    :src="item.pic1"
                    alt=""
                    style="width: 80px; height: 80px; border-radius: 10px"
                    @click="goGame(item.gid)"
                  />
                  <div>
                    <p>
                      {{ item.gamename }}
                    </p>
                    <p>{{ item.typeword }} {{ item.gamesize }}MB</p>
                    <div class="tag">
                      <span>{{ item.get_number }}人领取</span>
                      <span v-if="item.shoufa" class="first_serve">
                        <img src="../../assets/homepage/icon_firstServe.png" />
                      </span>
                      <span v-if="item.label" class="safe_play">
                        <img
                          src="../../assets/homepage/icon_hotwelfare_tag.png"
                          alt=""
                        />
                        {{ item.label }}
                      </span>
                    </div>
                  </div>
                </div>
                <span
                  v-if="item.is_get == '0'"
                  class="getCoupon"
                  @click="recievGold(item.cid, item.gid, i)"
                >
                  领取
                </span>
                <span v-else class="getCoupon hadGet">已领</span>
              </div>
            </van-cell>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>

    <!-- 领取成功弹出框 -->
    <van-popup
      v-model:show="state.showBottom"
      round
      position="bottom"
      :style="{ height: '37%' }"
    >
      <div class="popUp">
        <h1>领取成功</h1>
        <span>领取优惠券后请尽快使用，可在我 的优惠券或游戏内查看使用。 </span>
        <p @click="toGame">去下载</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  reactive,
  computed,
  onMounted,
  onUnmounted,
  onActivated,
  ref,
  nextTick,
} from "vue";
import { useRouter } from "vue-router";
import { Toast } from "vant";

import { Trial, getTrial, achieveTrial } from "@/api/yztask";
import { useStore } from "vuex";
import { dateMD } from "@/utils/date";
import defaultimg1 from "@/assets/defaultimg/error2.png";
import { get648, get648Coupon } from "@/api/yzgame";
import { getQueryString } from "@/utils/location";
import { setToken, getToken } from "../../utils/auth";

export default {
  name: "trygame",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      noimg: defaultimg1,
      num: "0",
      refresh: false,
      loading: false,
      finished: false,
      showNewList: false,
      nowpage: 1,
      trygamelist: [],
      couponList: [],
      showBottom: false,
      gid: "",

      backIcon: require("@/assets/nav/yz_nav_fh_w.png"),
    });
    onUnmounted(() => {
      window.removeEventListener("scroll", onScrollCard);
    }),
      onMounted(() => {
        if (getQueryString("token")) {
          setToken(getQueryString("token"));
        }
        scrollTo(0, 0);
      });
    var scrollDom = null;
    var titleColor = null;
    var rightTextColor = null;
    const onScrollCard = () => {
      var oDiv = window.document.getElementById("nav-topp");

      let scrollTop = scrollDom.scrollTop;
      if (scrollTop <= 100) {
        var alpha = parseInt((scrollTop / 100) * 255).toString(16);
        if (alpha < 77) {
          alpha = "00";
        }
        oDiv.style.backgroundColor = "#ffffff" + alpha; //设置fierfox等透明度，注意透明度值是小数
        titleColor.style.color = "#fff";
        rightTextColor.style.color = "#fff";
        state.backIcon = require("@/assets/nav/yz_nav_fh_w.png");
      } else {
        oDiv.style.backgroundColor = "#ffffff" + "FF";
        titleColor.style.color = " #12cec7";
        rightTextColor.style.color = " #12cec7";
        state.backIcon = require("@/assets/nav/yz_nav_fh.png");
      }

      // 切换为粘性定位
      if (scrollTop >= taskList.value.offsetTop - oDiv.offsetHeight) {
        taskList.value.style.borderRadius = "0";
        // taskList.value.style.position = "";
      } else {
        taskList.value.style.borderRadius = "20px";
        // taskList.value.style.position = "relative";
      }
    };

    const taskList = ref(null);

    // 试玩列表数据
    var ajaxFlag = false;
    const taskTrial = () => {
      if (ajaxFlag) {
        return;
      }
      ajaxFlag = true;
      let totalPage;
      get648({
        uid: getQueryString("uid"),
        pagecode: pagecode,
      }).then((response) => {
        ajaxFlag = false;
        // if (response.data.code == "1") {
        state.couponList = state.couponList.concat(response.data.lists);
        totalPage = response.data.total_page;
        // 加载状态结束
        state.loading = false;
        // 数据全部加载完成
        if (pagecode >= totalPage) {
          state.finished = true;
        }
        // 页数加一
        pagecode++;
        state.couponList = state.couponList.filter((item, index) => {
          return state.couponList.findIndex((v) => v.cid == item.cid) == index;
        });
      });
    };

    // 时间戳转换
    const time = computed(() => {
      return function(date) {
        return dateMD(date);
      };
    });

    // 返回
    const onClickLeft = () => {
      // router.back();
      window.document.location = "goBack://";
    };

    // 跳转游戏
    const goGame = (tid) => {
      window.document.location = "gogame://" + tid;
    };

    // 领取完奖励去下载游戏
    const toGame = () => {
      // router.push({ path: '/gamedetails', query: { gid: state.gid } })
      window.document.location = "gogame://" + state.gid;
    };

    // 领取奖励
    const recievGold = (cid, gid) => {
      // console.log('领取奖励的tid----------------',cid,gid)
      state.gid = gid;
      get648Coupon({
        cid: cid,
        uid: getQueryString("uid"),
      }).then((response) => {
        // console.log('领取奖励返回的数据----------------', response.data)
        if (response.data.code == 1) {
          // taskTrial(1)

          state.couponList.forEach((item, index) => {
            if (item.cid == cid) {
              item.is_get = "1";
            }
          });
          state.showBottom = true;
        } else {
          Toast(response.data.msg);
        }
      });
    };

    let pagecode = 1;
    // 加载试玩数据
    const onLoad = () => {
      // 异步更新数据
      taskTrial(pagecode);
    };

    const onRefresh = () => {
      state.loading = true;
      state.finished = false;
      state.couponList = [];
      pagecode = 1;
      state.refresh = false;
      taskTrial(pagecode);
    };

    const goMyCoupon = () => {
      window.document.location = "mycoupon://";
    };

    return {
      state,
      onClickLeft,
      onLoad,
      time,
      goGame,
      onRefresh,
      recievGold,
      goMyCoupon,
      toGame,
      taskList,
    };
  },
};
</script>

<style scoped src="../../styles/removeVantcell.css"></style>
<style scoped="scoped">
::v-deep .van-nav-bar__right {
  color: #fff;
}
::v-deep .van-nav-bar__title {
  color: #fff;
}
.van-nav-bar {
  background: none;
  top: 0px;
  left: 0px;
  width: 100%;
}

.van-hairline--bottom:after {
  border-bottom-width: 0;
}

.van-button {
  width: 112px;
  height: 56px;
  line-height: 56px;
  vertical-align: middle;
  font-size: 24px;
  font-family: PingFang SC-Medium;
  position: absolute;
  top: 4px;
  right: 4px;
}

.trygame-box {
  height: 100vh;
  overflow: hidden;
}

.trygame-content {
  background-color: #fff;
  height: 100vh;
  overflow: auto;
}

.tips-box {
  background: url("../../assets/yz/yz_648_bg.png") no-repeat center;
  background-size: 100% 100%;
  height: 468px;
  width: 100%;
}

.tips-box h3 {
  font-size: 32px;
  margin-bottom: 32px;
  color: #fff;
}

.tips-box p {
  font-size: 22px;
  margin-bottom: 6px;
  margin-left: 194px;
  color: red;
}

.hot {
  margin-top: 30px;
}

.task-list {
  margin-top: 30px;
  width: 100%;
  top: -100px;
  position: relative;
  background-color: #ffffff;
  padding: 38px 32px;
  border-radius: 40px 40px 0 0;
  height: 100%;
}
.van-list {
  padding-bottom: 350px;
}
.task-list .tips-info {
  font-size: 28px;
  color: #000000;
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.task-list .van-list {
  height: 100%;
}
.van-nav-bar__left img {
  width: 60px;
  height: 60px;
}
.van-cell__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.van-cell__left > div {
  line-height: 1.2;
}
.van-cell__left img {
  width: 160px;
  height: 160px;
  border-radius: 30px;
  margin-right: 20px;
}
:deep(.van-cell .van-cell__value) {
  overflow: hidden;
}

.van-cell__left p:nth-of-type(1) {
  font-size: 32px;
  align-items: center;
  max-width: 310px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  font-weight: 500;
  text-wrap: nowrap;
}
.van-cell__left p:nth-of-type(2) {
  font-size: 24px;
  color: #8f9197;
  margin-bottom: 8px;
}
.van-cell__left .tag {
  display: flex;
  align-items: center;
  height: 32px;
  text-wrap: nowrap;
}
.van-cell__left .first_serve {
  display: inline-block;
  width: 78px;
  height: 32px;
}
.van-cell__left .first_serve img {
  width: 78px;
  height: 32px;
  border-radius: 0;
}
.van-cell__left span:nth-of-type(1) {
  font-size: 24px;
  color: #666666;
  margin-right: 16px;
  border: 0;
  padding: 0;
  height: 32px;
  line-height: 44px;
}
.van-cell__left p:nth-of-type(2) {
  font-size: 24px;
  color: #999999;
}
.getCoupon {
  display: inline-block;
  width: 100px;
  height: 44px;
  background-color: #2acbaf;
  border-radius: 10px;
  font-size: 28px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 22px;
  line-height: 1;
}
.hadGet {
  background-color: #e6e6e6;
  color: #999999;
}
.van-cell {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: var(--van-cell-vertical-padding) var(--van-cell-horizontal-padding);
  overflow: hidden;
  color: var(--van-cell-text-color);
  font-size: var(--van-cell-font-size);
  line-height: var(--van-cell-line-height);
  background: var(--van-cell-background-color);
  background-color: #f7f7f7;
  border-radius: 20px;
  margin-bottom: 20px;
}

.popUp {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 60px 62px 60px 70px;
}
.popUp h1 {
  color: #333333;
  font-size: 42px;
}
.popUp span {
  color: #555555;
  font-size: 32px;
  margin: 68px 0 64px 0;
}
.popUp p {
  width: 562px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2acbaf;
  font-size: 44px;
  border-radius: 100px;
  color: #fff;
}

/* 福利 */

.van-cell__left .safe_play img {
  height: 30px;
  width: auto;
  margin: 0 2px 0 0;
  vertical-align: middle;
}
.van-cell__left .safe_play {
  height: 32px;
  font-size: 21px;
  line-height: 34px;
  border-radius: 4px;
  padding: 0 8px 0 4px;
  background-image: url("../../assets/homepage/icon_hotwelfare_tag_back.png");
  background-size: 100% 50%;
  background-repeat: no-repeat;
  background-position: bottom;
  margin-left: 8px;
  font-weight: 700;
  border: 0;
  color: #f99a11;
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
